<template lang="pug">
  main
    NavBarDucter
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    section.section.is-medium(v-show="!isLoading")
      .container
        .columns#logo
          .column.is-full.has-text-centered
            figure.image
              img#logoDucter(src='../assets/ducter_color.png')
            br
        .columns.has-text-dark
          .column.is-4-tablet.is-offset-4-tablet.is-4-desktop.is-offset-4-desktop.has-text-centered
            div.has-text-centered.column-login
              .field
                label.label.is-size-5 Usuario
                .control.has-icons-left.has-icons-right
                  input.input.is-dark.is-medium(
                    type='text',
                    placeholder='Nombre de usuario',
                    v-model="usuario",
                  )
                  span.icon.is-small.is-left
                    i.fas.fa-user
              .field
                label.label.is-size-5 Contraseña
                .control.has-icons-left.has-icons-right
                  input.input.is-dark.is-medium(
                    type='password',
                    placeholder='Contraseña',
                    v-model="password",
                    @keyup.enter="submitForm"
                  )
                  span.icon.is-small.is-left
                    i.fas.fa-key
            .field
        .columns
          .column.is-4.is-offset-4
            div.has-text-centered
              button.button.is-primary.is-large.is-rounded(@click="submitForm()" :disabled="isDisabled") Entrar
    Loader(v-show="isLoading")
</template>

<script>
import authServices from '@/services/auth'
import Loader from '@/components/shared/Loader.vue'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import NavBarDucter from '@/components/layout/NavBarDucter.vue'
import moment from 'moment'
import usuariosServices from '../services/usuarios/usuarios'

export default {
  name: 'Login',
  components: { Loader, ModalInfo, NavBarDucter },
  data () {
    return {
      usuario: '',
      password: '',
      isLoading: false,
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalNavBar: false,
      user: {},
      isDisabled: true,
      ipMachine: '',
      intentos: 0,
      bloqueado: false,
    }
  },
  watch: {
    usuario() {
      let simple = "'"
      let doble = '"'
      let comasimpleU = this.usuario.search(simple)
      let comillasU = this.usuario.search(doble)
      let comasimpleP = this.password.search(simple)
      let comillasP = this.password.search(doble)

      if (comasimpleU >= 0 || comillasU >=0 || comasimpleP >= 0 || comillasP >= 0)
      {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    password() {
      let simple = "'"
      let doble = '"'
      let comasimpleU = this.usuario.search(simple)
      let comillasU = this.usuario.search(doble)
      let comasimpleP = this.password.search(simple)
      let comillasP = this.password.search(doble)

      if (comasimpleU >= 0 || comillasU >=0 || comasimpleP >= 0 || comillasP >= 0)
      {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    }

  },
  methods: {
    submitForm () {
      if (this.isDisabled) {
        return false
      }
      let simple = "'"
      let doble = '"'
      let comasimpleU = this.usuario.search(simple)
      let comillasU = this.usuario.search(doble)
      let comasimpleP = this.password.search(simple)
      let comillasP = this.password.search(doble)

      if (comasimpleU >= 0 || comillasU >=0 || comasimpleP >= 0 || comillasP >= 0)
      {
        this.isDisabled = true
      } else {
        this.isDisabled = false
        this.isLoading = true

        this.checarBloqueo()
      }

    },
    convertirDataUser(user) {
      return {
        ...user,
        categoria: parseInt(user.categoria),
        departamento: parseInt(user.departamento),
        jefeArea: parseInt(user.jefeArea),
        id_ubicacion: parseInt(user.id_ubicacion),
        id_oficina: parseInt(user.id_oficina),
      }
    },

    registrarAcceso () {
      var fh = moment().format('YYYY-MM-DD HH:mm:ss')
      authServices.registrarAcceso(fh, this.user.usuario)
        .then( res => {
          console.log(res)
          if (res.success) {
            usuariosServices.obtenerPermisos_User(this.user.id)
              .then( dataP => {
                const permisos = this.convetirPermisos(dataP[0])
                this.$store.commit('setPermisos', permisos)
                this.entrarSistema(this.user.ubicacion)
              })
              .catch(e => {
                this.displayToast('bubble',e.message, 'ban', 'Ok')
              })
          } else {
            console.log(res.respuesta)
          }
        })
    },

    convetirPermisos(permiso) {
      return {
        ...permiso,
        id: parseInt(permiso.id),
        sca_tpa: parseInt(permiso.sca_tpa),
        sca_irge: parseInt(permiso.sca_irge),
        inventarios: parseInt(permiso.inventarios),
        monitoreo: parseInt(permiso.monitoreo),
        combustibles: parseInt(permiso.combustibles),
        tarjetas: parseInt(permiso.tarjetas),
        tags: parseInt(permiso.tags),
        vehiculos: parseInt(permiso.vehiculos),
        reportes: parseInt(permiso.reportes),
        responsivas: parseInt(permiso.responsivas),
        requisiciones: parseInt(permiso.requisiciones),
        facturas: parseInt(permiso.facturas),
        visitas: parseInt(permiso.visitas),
        permisos_videos: parseInt(permiso.permisos_videos),
      }
    },
    entrarSistema (direccion) {
      this.modalNavBar = true
      this.$store.commit('setlogin', this.modalNavBar)
      this.$store.commit('irEstaciones', direccion)

      if (this.user.cargo === '002' || this.user.cargo === '2100' || this.user.cargo === '2200') {
        this.$router.push('/GerenciaAdmin')
        return
      }
      if (this.user.cargo === '210' || this.user.cargo === '230') {
        this.$router.push('/HomeGia')
        return
      }
      if (this.user.cargo === '310' || this.user.cargo === '330') {
        this.$router.push('/SoporteGIA')
        return
      }
      if (this.user.cargo === '331' || this.user.cargo === '332') {
        this.$router.push('/Almacenista')
        return
      }
      if (this.user.cargo === '120' || this.user.cargo === '121' || this.user.cargo === '160') {
        this.$router.push('/Asistentes')
        return
      }
      if (this.user.cargo === '345') {
        this.$router.push('/Externo')
        return
      }
      if (this.user.cargo === '323') {
        this.$router.push('/Auditoria')
        return
      }
      if (this.user.cargo === '324') {
        this.$router.push('/Auditoria')
        return
      }
      if (this.user.cargo === '428') {
        this.$router.push('/Visitas/Corpo')
        return
      }
      if (this.user.cargo === '429') {
        this.$store.commit('origenCorpoVisita', 0)
        this.$router.push('/Visitas/Corpo/Nuevo')
        return
      }
      if (this.user.cargo === '430') {
        this.$store.commit('origenCorpoVisita', 1)
        this.$router.push('/Visitas/Corpo/Nuevo')
        return
      }
      if (this.user.cargo === '431') {
        this.$store.commit('origenCorpoVisita', 2)
        this.$router.push('/Visitas/Corpo/Nuevo')
        return
      }

      if (this.user.cargo === '990') {
        this.$router.push('/Monitor')
        return
      }

      if (this.user.cargo === '991') {
        location.href = '/reportesApp/home.html'
        return
      }

      switch (direccion) {
        case 'IRGE':
          this.$store.commit('irEstaciones', direccion)
          this.$router.push('/IRGE')
          break
        case 'TPA':
          this.$store.commit('irEstaciones', direccion)
          this.$router.push('/TPA')
          break
        case 'EB00':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'EB01':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'EB02':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'EB03':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'EB04':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'ERM':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'LPG_DUCTO':
          this.$store.commit('irEstaciones', 'DUCTO')
          this.$router.push('/Estacion')
          break
        case 'CORPORATIVO':
          this.$router.push('/Corporativo')
          break
        case 'ALL':
          this.$store.commit('irEstaciones', direccion)
          this.$router.push('/Admin')
          break
        case 'EXT':
          this.$router.push('/Externo')
          break
        case 'REM':
          this.$router.push('/Monitor')
          break
        default:
          break
      }
    },
    cerrarModal () {
      this.modalStatus = false
    },
    displayToast(tema, text, icon, actionText) {
      let toast = this.$toasted.show(text, {
        theme: tema,
        position: "bottom-right",
        duration : null,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    checarBloqueo () {
      authServices.checkBloqueo(this.usuario)
        .then( dataB => {
          if (Object.keys(dataB).length > 0) {
            const fechaValida = moment().isAfter(dataB[0].desbloqueo)
            console.log('fecha valida' + fechaValida)
            this.bloqueado = !fechaValida
            this.loguearse()
          } else {
            this.bloqueado = false
            this.loguearse()
          }
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',e.message, 'ban', 'OK')
        })
    },
    loguearse () {
      if (this.bloqueado) {
        this.displayToast('bubble','El usuario ha sido bloqueado, debe esperar 15 min para poder ingresar de nuevo.')
        this.isLoading = false
      } else {
        authServices.signin(this.usuario, this.password)
          .then(res => {
            if (Object.keys(res).length > 0) {
              if (res.success) {
                this.user = this.convertirDataUser(res)
                usuariosServices.checarCaducidadPass(this.user.id, this.password)
                  .then( data => {
                    const hoy = moment().format('YYYY-MM-DD')
                    const { caducidad } = data[0]
                    const caducaYN = moment(hoy).isAfter(caducidad)
                    const caducaHoy = moment(caducidad).isSame(hoy)
                    let passCaducada = true

                    if (!caducaHoy && !caducaYN) {
                      passCaducada = false
                    }
                    this.isLoading = false
                    if (passCaducada) {
                      this.displayToast('bubble','Su Contraseña ha Caducado. ', 'ban', 'OK')
                      this.$store.commit('usuarioLogueado', this.user)
                      this.$router.push('/passwords/Generador')
                    } else {
                      sessionStorage.setItem('idUsuario', this.user.id)
                      sessionStorage.setItem('usuario', this.user.usuario)
                      sessionStorage.setItem('nombre', this.user.nombre)
                      sessionStorage.setItem('nombre_file', this.user.nombre_file)
                      sessionStorage.setItem('categoria', this.user.categoria)
                      sessionStorage.setItem('departamento', this.user.departamento)
                      sessionStorage.setItem('departamentoStr', this.user.departamentoStr)
                      sessionStorage.setItem('cargo', this.user.cargo)
                      sessionStorage.setItem('jefeArea', this.user.jefeArea)
                      sessionStorage.setItem('ubicacion', this.user.ubicacion)
                      sessionStorage.setItem('oficina', this.user.oficina)
                      sessionStorage.setItem('email', this.user.email)
                      sessionStorage.setItem('avatar', this.user.avatar)
                      sessionStorage.setItem('telefono', this.user.telefono)
                      this.$store.commit('usuarioLogueado', this.user)
                      this.registrarAcceso()
                    }
                  })
                  .catch( e => {
                    this.displayToast('bubble',e.message, 'ban', 'OK')
                  })
              } else {
                this.isLoading = false
                this.displayToast('bubble',res.respuesta, 'ban', 'OK')
                this.intentos = this.intentos + 1
                if (this.intentos >= 4) {
                  this.bloqueado = true
                  const desbloqueo = moment().add(15, 'minutes')
                  authServices.bloquearUser(this.usuario, desbloqueo.format('YYYY-MM-DD HH:mm:ss'))
                    .then(dataBlocked => {
                      this.displayToast('bubble','El usuario ha sido bloqueado, debe esperar 15 min para poder ingresar de nuevo.')
                    })
                    .catch((error) => {
                        this.isLoading = false
                        this.displayToast('bubble',error.message, 'ban', 'OK')
                      })
                }
              }
            } else {
              this.isLoading = false
              this.displayToast('bubble','Error en autenticación. Verifique su usuario y/o contraseña.', 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      }
    }
  },
}
</script>

<style lang="css" scoped>
  #logoDucter {
    max-width: 300px;
    height: auto;
  }
  .image {
    display: inline-block;
  }
  #logo {
    margin-bottom: 30px;
  }

  @media (min-width:641px) and (orientation: portrait) {
    .column-login {
      width: 30vh;
      margin-left: 20vh;
    }
  }

</style>





// WEBPACK FOOTER //
// src/components/Login.vue